import { useEffect, useRef } from "react";
import { InstantSearch, useInstantSearch } from "react-instantsearch";
import { toIndexUiState } from "../chat/filters";
import { Filters } from "../filter/Facet";
import { useWorkspaceSearch } from "./search";

const future = { preserveSharedStateOnUnmount: true };

// Zet de criteria van een aangeklikt filter om naar InstantSearch-uiState.
// De ref houdt setIndexUiState stabiel: een inline arrow als effect-dependency
// geeft een oneindige render-loop.
const ApplyCriteria = () => {
  const { setIndexUiState } = useInstantSearch();
  const setStateRef = useRef(setIndexUiState);
  useEffect(() => {
    setStateRef.current = setIndexUiState;
  });

  const criteria = useWorkspaceSearch((s) => s.criteria);
  const appliedAt = useWorkspaceSearch((s) => s.appliedAt);

  // Ook op `appliedAt`: dezelfde chip nog eens aanklikken laat `criteria`
  // ongemoeid (zelfde object), maar moet wél opnieuw zoeken — anders blijven de
  // zoekparameters leeg die `apply()` net heeft gewist.
  useEffect(() => {
    setStateRef.current(criteria ? toIndexUiState(criteria) : {});
  }, [criteria, appliedAt]);

  return null;
};

// Headless: geen facet-UI en geen `routing` (dat zou de workspace-URL
// overschrijven). De widgets van /search staan er wel, maar verborgen — anders
// heeft setIndexUiState geen effect.
export const WorkspaceSearch = ({ children }: { children: React.ReactNode }) => {
  const client = useWorkspaceSearch((s) => s.client);
  return (
    <InstantSearch indexName="reference" searchClient={client} future={future}>
      <div className="hidden">
        <Filters />
      </div>
      <ApplyCriteria />
      {children}
    </InstantSearch>
  );
};
